<template>
	<div
		:id="chartsPieRingData.id"
		class="charts"
		:style="{ width: '100%', height: chartsPieRingData.height }"
		ref="echarts"
	></div>
</template>

<script>
//引入Echarts主模块
var echarts = require("echarts/lib/echarts");
//引入饼图
require("echarts/lib/chart/pie");
//引入提示框、标题组件、工具栏、缩放组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/toolbox");
require("echarts/lib/component/dataZoom");
require("echarts/lib/component/legend");
export default {
	props: ["chartsPieRingData"],
	data() {
		return {};
	},
	mounted() {
		this.drawCharts();
	},
	methods: {
		drawCharts() {
			// 基于准备好的dom，初始化echarts实例
			// var myChart = echarts.init(document.getElementById(this.chartsPieRingData.id));
			var myChart = echarts.init(this.$refs.echarts);
			window.addEventListener("resize", () => {
				//echarts自适应宽度
				window.onresize = myChart.resize();
			});
			const colorList = this.chartsPieRingData.colorData; //顺序修改删除增加
			// 绘制图表
			myChart.setOption({
        title: {
          text: this.chartsPieRingData.name,
          y: 0,
          x: 10,
          textStyle: {
            //文本样式
            color:"#606266",// 蓝色#295d99 橘色#b8573c
            fontWeight:400,
            fontSize: 14,
            lineHeight: 18
          }
        },
				grid: {
					//图表位置
					top: "7%",
					right: "3.5%",
					left: "90px",
					bottom: this.chartsPieRingData.bottom,
				},
				toolbox: {
					//工具栏
					show: true,
					right: "1%",
					top: "0%",
					feature: {
						// dataView : {show: true, readOnly: false}, //数据视图工具
						// magicType: { show: true, type: ["line", "bar"] },//动态类型切换
						// restore: { show: true }, //配置项还原
						saveAsImage: {
							//保存为图片
							show: true,
							name: this.chartsPieRingData.name,
						},
					},
				},
				tooltip: {
					trigger: "item",
				},
				legend: {
					top: "2%",
					left: "center",
					textStyle: {
						color: "#000",
						fontSize: 14,
					},
				},
				series: [
					// {
					// 	name: "审查意见",
					// 	type: "pie",
					// 	radius: ["25%", "40%"],
					// 	avoidLabelOverlap: false,
					// 	label: {
					// 		show: false,
					// 		position: "center",
					// 	},
					// 	emphasis: {
					// 		label: {
					// 			show: true,
					// 			fontSize: "40",
					// 			fontWeight: "bold",
					// 		},
					// 	},
					// 	labelLine: {
					// 		show: false,
					// 	},
					// 	data: this.chartsPieRingData.data,
					// },
					{
						type: "pie",
						// name: "审查意见",
						center: ["50%", "40%"],
						radius: ["25%", "40%"],
						top: "40px",
						left: "center",
						minAngle: 10,
						avoidLabelOverlap: true,
						hoverOffset: 15,
						itemStyle: {
							color: (params) => {
								return colorList[params.dataIndex];
							},
						},
						label: {
							show: true,
							position: "outer",
							alignTo: "labelLine",
							// ·圆点
							backgroundColor: "auto", //圆点颜色，auto：映射的系列色
							height: 0,
							width: 0,
							lineHeight: 0,
							// height,width.lineHeight必须为0
							distanceToLabelLine: 0, //圆点到labelline距离
							borderRadius: 2.5,
							padding: [2.5, -2.5, 2.5, -2.5],
							//radius和padding为圆点大小，圆点半径为几radius和padding各项数值就为几如：圆点半径为1borderRadius: 1,padding: [1, -1, 1, -1]

							formatter: "{a|{b}：}{b|{d}%}", //a系列名 b数据名 c数据值 d百分比
							// formatter: function(e) {
                     //       // console.log(e)
                     //       var newStr=" ";
							// 		var start,end;
							// 		var name_len=e.name.length;
							// 		var max_name=8;
							// 		var new_row = Math.ceil(name_len / max_name);// 最多能显示几行，向上取整比如2.1就是3行
							// 		if(name_len>max_name){//如果长度大于每行最多显示的字数
							// 			for(var i=0;i<new_row;i++){//循环次数就是行数
							// 				var old='';//每次截取的字符
							// 				start=i*max_name;//截取的起点
							// 				end=start+max_name;//截取的终点
							// 			if(i==new_row-1){//最后一行就不换行了
							// 				old=e.name.substring(start);
							// 			}else{
							// 				old=e.name.substring(start,end)+"\n";
							// 			}
							// 				newStr+=old; //拼接字符串
							// 			}
							// 		}else{  //如果小于每行最多显示的字数就返回原来的字符串
							// 			newStr=e.name; 
							// 		}
							// 		return newStr +'：' +e.percent+'%';
                     //    },
							rich: {
								a: {
									padding: [0, 0, 0, 10],
									fontSize: 14,
									// align:"center",
									// color: '#000',
								},
								b: {
									padding: [0, 10, 0, 0],
									fontSize: 14,
								},
								hr: {
									width: "100%",
									height: 0,
									align: "center",
								},
								d: {
									color: "#000",
									fontSize: 30,
								},
							},
						},
						data: this.chartsPieRingData.data,
					},
				],
			});
			//点击图表跳转
			// myChart.off('click');
			// myChart.on('click',(params)=>{
			//   console.log(params)
			//   //dataIndex 数据索引值
			//   console.log(this.chartsPieRingData.path)
			//   var url=this.$router.resolve({
			//     path: this.chartsPieRingData.path,
			//     // query: { uuid: _this.uuid[params.dataIndex] }
			//     query: { id:this.chartsPieRingData.idNum[params.dataIndex]}
			//   });
			//   window.open(url.href,'_blank');
			// });
		},
	},
};
</script>
<style scoped>
</style>
